import { defaultTemplate } from "@smart/bridge-templates-basic";
import {
  Button,
  ContactDisplay,
  Displayer,
} from "@smart/itops-sb-design-system-dom";

import { AutofillFeedback } from "./autofill-components";
import { IntakePrintProps, useIntakePrint } from "./print-components";
import { PageWrapper, Section } from "./section-components";
import { AutoFillStatus, SubmissionItem, TeamItem } from "../types";

export type IntakeStatusProps = {
  isMatterClosed?: boolean;
  team: TeamItem;
  response?: string;
  category?: string;
  status?: SubmissionItem["status"];
  deleted?: boolean | null;
  printOptions?: IntakePrintProps;
  autoFillStatus?: AutoFillStatus;
  onSubmitAutofillFeedback?: (feedback?: string) => Promise<void>;
};

export const IntakeStatus = ({
  isMatterClosed,
  team,
  response,
  category,
  status,
  deleted,
  printOptions,
  autoFillStatus,
  onSubmitAutofillFeedback,
}: IntakeStatusProps) => {
  const { onPrint, elements } = useIntakePrint(printOptions);
  let statusText = "has been completed";
  if (isMatterClosed || status === "cancelled") statusText = "has been closed";
  if (status === "draft") statusText = "is not currently available";
  if (deleted) statusText = "has been removed";

  return (
    <PageWrapper sidebar={false}>
      <div
        className="bg-white rounded-small 
        m-[0.4rem] mobile:mx-auto mobile:mt-[3rem] mobile:mb-[10rem] 
        max-w-full mobile:max-w-[90%] mobile:w-fit 
        h-[90.5%] mobile:h-fit 
        shadow-dropdownMenu"
      >
        <Section
          dataTestId="status-content"
          className="tablet:w-[59.2rem] h-full"
        >
          {!deleted && status === "completed" && (
            <div className="flex flex-col h-full items-center justify-center gap-[3.2rem] text-paragraph mx-auto px-[2.4rem] py-[4rem]">
              <Displayer
                paragraphTag="p"
                value={response}
                fallback={defaultTemplate.response}
                placeholderData={{
                  downloadFormLink: "#download",
                  firmName: team.name,
                  firmPhone: team.phone || "",
                  matterCategory: category || "matter",
                }}
                onPlaceholderClick={(e, element) => {
                  if (element.name === "downloadFormLink") {
                    e.preventDefault();
                    onPrint();
                  }
                }}
              />
              <div className="w-full flex justify-center">
                <Button
                  variant="primarySubtle"
                  text="Save Form"
                  onClick={() => onPrint()}
                />
              </div>
            </div>
          )}
          {(deleted || isMatterClosed || status !== "completed") && (
            <p>
              This form {statusText}. Please{" "}
              <ContactDisplay
                link={(team.email && `mailto:${team.email}`) || undefined}
                text={team.name || "us"}
              />{" "}
              if you have any further questions.
            </p>
          )}
          <AutofillFeedback
            open={autoFillStatus === "completed"}
            onSubmit={onSubmitAutofillFeedback}
          />
        </Section>
      </div>
      {elements}
    </PageWrapper>
  );
};
